import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';

const OurClients = () => {
  const logos = [
    'logo1.png',
    'logo2.png',
    'logo3.png',
    'logo4.png',
    'logo5.png',
    'logo7.png',
    'logo8.png',
    'logo9.png',
    'logo10.png',
    'logo11.png',
  ]; // Make sure these images exist in public/images/ or import them

  return (
    <div className="our-clients">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="our-clients-box">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp" style={{ fontSize: 25 }}>
                  BRAND RECOMMENDATIONS
                </h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Trusted by the Brands You Trust
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Collaborating with the finest names in interiors. From materials to
                  finishes, our work is backed by the brands that set industry
                  standards. These trusted partnerships help us ensure that every
                  space we design is built with quality, durability, and refined
                  aesthetics&nbsp;in&nbsp;mind.
                </p>
              </div>
              {/* Section Title End */}

              {/* Logo Slider Section */}
              <div className="logo-slider-section">
                <Swiper
                  className="logoSwiper"
                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  spaceBetween={20}
                  slidesPerView={3}
                  breakpoints={{
                    768: {
                      slidesPerView: 6,
                    },
                  }}
                  modules={[Autoplay]}
                >
                  {logos.map((logo, index) => (
                    <SwiperSlide key={index}>
                      <div className="logo-box">
                        <img src={`images/${logo}`} alt={`Logo ${index + 1}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              {/* Logo Slider Section End */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurClients;
